import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { withExtensionManifest } from '../withExtensionManifest';
var itemBodyStyles = xcss({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  margin: 'space.200',
  flexGrow: 3
});
var itemTextStyles = xcss({
  maxWidth: '100%',
  whiteSpace: 'initial'
});
var summaryStyles = xcss({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: 'color.text.subtlest',
  marginTop: 'space.050',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});
function HeaderAfterIconElement(_ref) {
  var extensionManifest = _ref.extensionManifest;
  var title = extensionManifest.title;
  var summary = extensionManifest.summary;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: itemBodyStyles
  }, summary ? /*#__PURE__*/React.createElement(Box, {
    xcss: itemTextStyles
  }, /*#__PURE__*/React.createElement("div", {
    id: "context-panel-title",
    "data-testid": "context-panel-title"
  }, title), /*#__PURE__*/React.createElement(Box, {
    xcss: summaryStyles
  }, summary)) : /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    alignItems: "center",
    testId: "context-panel-title"
  }, title));
}
export default withExtensionManifest(HeaderAfterIconElement);